/**
 * lightGallery commercial license key.
 *
 * Validated in the browser, so it ships in the client bundle by design —
 * this is not a secret. Keep it here so every lightGallery instance
 * (inline carousel, modal, image gallery) stays in sync.
 */
export const LIGHTGALLERY_LICENSE_KEY = '4B0B052C-5BCB4CCF-99EF0E30-D0B78394';
